<template>
  <div class="plan-subscription--wrap"
       :class="[`step-${step}`, { upgrade: planUpdating === 'upgrade',
                                  downgrade: planUpdating === 'downgrade',
                                  short: domains.length < 1 }]">
    <div class="step plan-list">
      <i class="icon icon--close-size16" @click="onCloseLayer"></i>
      <h2 class="title">{{ $t('plan.changePlan') }}</h2>
      <p class="description"  v-html="$t('plan.planChoose')"></p>
    </div>
    <transition name="fade-second">
      <plan-steps class="step" v-if="newPlan && step === 1"
                  :newPlan="newPlan"
                  @change="onPlanChange"
                  @contactUs="contactUs"
                  @onPlanChange="isPlanChange"
                  @closeLayer="onCloseLayer"
                  @onBack="onBack"/>
    </transition>
    <transition name="fade">
      <div class="step plan-confirm" v-if="step === 2">
        <div class="confirm-content" ref="scrollArea">
          <h3 class="title">{{ $t('plan.changePlanConfirm.title') }}</h3>
          <div class="plan-to-plan">
            <div class="current">
              <h4>{{ $t('plan.changePlanConfirm.nowUsing') }}</h4>
              <p>{{ planData.planName }}</p>
            </div>
            <div class="arrow">
              <i class="icon icon--arrow-body-right-gray"></i>
            </div>
            <div class="next">
              <h4>{{ $t('plan.changePlanConfirm.changeTo') }}</h4>
              <p v-if="newPlan">{{ newPlan.planName }}</p>
            </div>
            <div class="renew-price">
              <div class="price__wrap">
                <div class="name"><span style="margin-right: 5px;">{{ newPlan.planName }}</span>{{ $t('plan.changePlanConfirm.total') }}</div>
                <div class="number" v-if="newPlan.planNumber !== 300">
                  <strong>￦ {{ (newPlan.originPrice || newPlan.price) | thousand }}</strong>
                  <span>({{ $t('payment.noVat') }})</span>
                </div>
                <div class="number" v-else>
                  <strong>{{ $t('plan.free') }}</strong>
                </div>
              </div>
              <div class="dashed-line"></div>
              <div class="price__wrap plan-info 123123">
                <div class="price-item pv">
                  <div class="name">{{ $t('common.providedPV') }}</div>
                  <div class="value">
                    <strong>{{ newPlan.pvLimit | thousand }} PV</strong>
                  </div>
                </div>
                <div class="price-item ai-docent">
                  <div class="name">{{$t('pricing.aiDocent')}}</div>
                  <div class="value">
                    <strong>{{ newPlan.docentCredit | thousand }} {{$t('pricing.count')}}/ {{ $t(`pricing.${getNewInfo}`)}}</strong>
                  </div>
                </div>
                <div class="price-item jam" v-if="newPlan.jam !== 0">
                  <div class="name">JAM</div>
                  <div class="value">
                    <strong>{{ newPlan.jam | thousand }} {{ $t('pricing.ea') }}</strong>
                  </div>
                </div>
              </div>
              <template v-if="newPlan.referral && (newPlan.planNumber !== 300 && newPlan.planNumber !== 401 )">
              <div class="dashed-line"></div>
              <div class="price__wrap plan-info">
                <div class="price-item pv">
                  <div class="name">{{ $t('plan.changePlanConfirm.referralDiscount') }}</div>
                  <div class="value">
                    <strong>(-) ￦ {{ newPlan.originPrice * 0.1 | thousand }}</strong>
                  </div>
                </div>
              </div>
              </template>
              <template v-if="planUpdating === 'upgrade'">
                <div class="dashed-line"></div>
                <div class="price__wrap plan-info">
                  <div class="price-item pv">
                    <div class="name">{{ $t('plan.changePlanConfirm.transferRemain', { currentPlan: planData.planName }) }}</div>
                    <div class="value">
                      <strong>￦ {{ getRemainDiscount| thousand }}</strong>
                      <span>({{ $t('plan.changePlanConfirm.decimalRounding') }})</span>
                    </div>
                  </div>
                </div>
              </template>
              <div class="dashed-line"></div>
              <div class="price__wrap">
                <div class="name">{{ $t('pricing.totalPrice') }}</div>
                <div class="number" v-if="newPlan.planNumber !== 300">
                  <strong>￦ {{ getTotalPrice | thousand }}</strong>
                  <span>({{ $t('payment.noVat') }})</span>
                </div>
                <div class="number" v-else>
                  <strong>{{ $t('plan.free') }}</strong>
                </div>
              </div>
            </div>
            <ul class="description downgrade"
                v-if="planUpdating === 'downgrade'">
              <li v-html="$t('plan.changePlanConfirm.downgrade.desc1', { newPlan: currentPlan.planName, startDate: nextStartDate })"></li>
              <li v-html="$t('plan.changePlanConfirm.downgrade.desc2')"></li>
            </ul>
            <ul class="description upgrade"
                v-else>
              <li v-html="$t('plan.changePlanConfirm.upgrade.desc0')"></li>
              <li v-html="$t('plan.changePlanConfirm.upgrade.desc1')"></li>
              <li v-html="$t('plan.changePlanConfirm.upgrade.desc2')"></li>
              <li v-html="$t('plan.changePlanConfirm.upgrade.desc3')"></li>
              <li v-html="$t('plan.changePlanConfirm.upgrade.desc4')"></li>
            </ul>
          </div>
        </div>
        <div class="footer">
          <div class="footer-description">
            <ui-checkbox v-model="isTermsAgree">
              <span class="terms-agree">
                {{ $t('plan.agree') }}
              </span>
            </ui-checkbox>
          </div>
          <span v-if="hasTermsError"
                class="terms-agree-validation-text">
            {{ $t('common.validationErrorText.requiredAgree') }}
          </span>
          <div class="button--wrap">
            <ui-button class="btn__cancel"  @click="onBack">
              {{ $t('common.cancel') }}
            </ui-button>
            <ui-button class="btn__confirm"
                       :primary="true"
                       :disabled="!canChangePlan || !isTermsAgree"
                       @click="onConfirm">
              {{ $t('common.confirm') }}
            </ui-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { create } from 'vue-modal-dialogs'
import { format } from 'date-fns'
import { checkBeforeUpdate } from '@/api/userPlan'
import { getDomains } from '@/api/domain'
import { getCardInfo } from '@/api/card'
import { openContactUs, thousand } from '@/libs/utils'
import { PLAN_NUMBER } from '@/libs/plan-helper'

import AppDialog from '@/components/ui/AppDialog'
import UiButton from '@/components/ui/UiButton'
import UiCheckbox from '@/components/ui/UiCheckbox'
import PlanSteps from '@/components/user-info/manage-plan/PlanSteps.vue'
import { PLAN_NAME } from '@/libs/constants'

const openDialog = create(AppDialog)

export default {
  name: 'PlanSubscription',
  components: {
    PlanSteps,
    UiButton,
    UiCheckbox
  },
  // props: ['initialPlan', 'applyData'],
  props: {
    initialPlan: {
      type: Boolean
    },
    applyData: {
      type: Object,
      default: () => { return null }
    },
    remainCredit: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      discountPV: 0,
      planPV: 0,
      step: 1,
      currentPlan: null,
      newPlan: null,
      creditApply: null,
      selectedPlan: null,
      planUpdating: false,
      isTermsAgree: false,
      hasTermsError: false,
      hasDomainError: false,
      domains: [],
      isEditMode: {},
      pvLimit: {},
      showingPvLimit: {},
      showPvLimitList: false,
      overflowPvLimitList: false,
      planActive: 0,
      canChangePlan: true,
      defaultCustomPvLimit: 10000,
      scrollAnimation: null,
      isMac: false
    }
  },
  computed: {
    getTemsUrlPart () {
      return '뷰저블 ' + `<a href=${this.getTermsUrl} target='_blank' style='color: #4C9AFF; text-decoration: underline;'>이용 약관</a>을 확인했으며, 이에 동의합니다.`
    },
    getRemainDiscount () {
      if (this.userData.planNumber === 300 || this.planUpdating === 'downgrade') return 0

      const unusedRatio = Math.ceil((this.discountPV / this.planPV) * 100) / 100

      return Math.ceil((this.currentPlan.price / 1.1) * unusedRatio)
    },
    getTotalPrice () {
      const isReferralDiscountTarget =
        this.newPlan.referral &&
        this.newPlan.planNumber !== 300 &&
        this.newPlan.planNumber !== 401

      const referralDiscount = isReferralDiscountTarget
        ? this.newPlan.originPrice * 0.1
        : 0

      const remainDiscount =
        this.planUpdating === 'upgrade' ? this.getRemainDiscount : 0

      return this.newPlan.price - referralDiscount - remainDiscount
    },
    ...mapState([
      'planData',
      'userData'
    ]),
    getHeatmapState () {
      return (data) => {
        if (new Date() < new Date(data.startDate)) {
          return 'schedule'
        }

        if (data.state && data.state.startsWith('stopBy')) {
          return 'stopBy'
        }

        return data.state
      }
    },
    getNewInfo () {
      return this.applyData.isYearly === 'false' ? 'month' : 'year'
    },
    priceWidthVAT () {
      return parseInt(this.newPlan.price * 1.1)
    },
    nextStartDate () {
      if (this.planData && this.planData.next) {
        return format(this.planData.next.startDate, 'YYYY-MM-DD')
      }
      return '???'
    }
  },
  watch: {
    step () {
      this.isTermsAgree = false
    }
  },
  created () {
    this.thousand = (value) => thousand(value)
    this.setPlanActive(this.planData.planNumber)
    if (this.initialPlan) {
      this.step = 1
      this.onPlanChange(this.initialPlan)
    }
    this.isMac = navigator.platform.indexOf('Mac') > -1
  },
  mounted () {
    if (this.applyData && this.applyData.planName) {
      this.applyData.type = PLAN_NAME.find(name => this.applyData.planName.includes(name))
      this.isPlanChange(true, this.applyData)
    }
  },
  methods: {
    format,
    handleJamForum () {
      window.open('https://forum.beusable.net/ko/solomon/main', '_blank')
    },
    onPlanChange (planNumber, isPayments = null, isNext = false) {
      this.hasTermsError = false
      this.hasDomainError = false
      this.showPvLimitList = false

      if (planNumber) {
        checkBeforeUpdate(planNumber)
          .then(result => {
            this.creditApply = result.creditApply
            this.currentPlan = result.current
            this.discountPV = result.discountPV
            this.planPV = result.planPV

            this.newPlan = this.selectedPlan ? { ...this.selectedPlan, ...result.next } : result.next
            if (this.newPlan.isDowngrade) {
              this.planUpdating = 'downgrade'
            } else if (this.newPlan.isSame) {
              if (this.currentPlan.pvLimit === this.newPlan.pvLimit && this.currentPlan.aiReportCredit === this.newPlan.aiReportCredit) {
                this.planUpdating = 'same'
              } else {
                this.planUpdating = 'downgrade'
              }
            } else {
              this.planUpdating = 'upgrade'
            }
            this.newPlan.grade = this.planUpdating
            if (this.planUpdating === 'same') {

            } else if (this.newPlan.planNumber !== 300) {
              getDomains(null, true).then(result => {
                this.domains = result
                this.domains.map(domain => {
                  this.$set(this.pvLimit, domain.orgSid, domain.pvLimit)
                  this.$set(this.showingPvLimit, domain.orgSid, -1)
                  this.$set(this.isEditMode, domain.orgSid, false)
                })
              })
              if (isNext) this.step = 2
            } else {
              if (isNext) this.step = 2
            }
          })
          .catch(err => {
            if (!err.isHandled) {
              openDialog({
                dialogType: 'common.error'
              })
            }
          })
      } else {
        this.newPlan = null
      }
    },

    setOverflowPvLimitList (value) {
      if (value) {
        this.overflowPvLimitList = true
        setTimeout(() => {
          this.overflowPvLimitList = true
        }, 300)
      } else {
        setTimeout(() => {
          this.overflowPvLimitList = false
        }, 300)
      }
    },

    toggleShowPvLimitList () {
      this.setOverflowPvLimitList(false)
      this.showPvLimitList = !this.showPvLimitList
      if (this.showPvLimitList) {
        const initialScroll = this.$refs.scrollArea.scrollTop
        let scrollTiming = 0
        this.scrollAnimation = setInterval(() => {
          this.$refs.scrollArea.scrollTop = initialScroll - (1 - Math.pow(1 - scrollTiming, 2)) / 10
          scrollTiming++
          if (scrollTiming > 100) {
            clearInterval(this.scrollAnimation)
          }
        }, 10)
      }
    },

    onPvLimitEditable (domain, value) {
      if (value) {
        this.$set(this.showingPvLimit, domain, 10000)
        this.$set(this.pvLimit, domain, 10000)
      } else {
        this.$set(this.showingPvLimit, domain, -1)
        this.$set(this.pvLimit, domain, -1)
      }
      this.$set(this.isEditMode, domain, value)
    },

    onPvLimitDropdownToggle (value) {
      this.setOverflowPvLimitList(value)
    },

    onShowingPVLimitChange (domain, value) {
      this.$set(this.showingPvLimit, domain, value)
      if (value === 0) {
        this.$set(this.pvLimit, domain, 10000)
      } else {
        this.$set(this.pvLimit, domain, value)
      }
    },

    onPVLimitChange (domain, value, force = false) {
      if (value === undefined) {
        value = this.pvLimit[domain]
      }
      value = String(parseInt(value) || '')
      if (force && (!value || parseInt(value) < 1)) {
        value = 1
      }
      this.$set(this.pvLimit, domain, value)
    },

    onConfirm () {
      this.hasTermsError = false
      this.hasDomainError = false

      if (!this.isTermsAgree) {
        this.hasTermsError = true
      }

      let pvLimits = []
      if (this.planUpdating === 'upgrade') {
        for (const [orgSid, pvLimit] of Object.entries(this.pvLimit)) {
          pvLimits.push({ orgSid, pvLimit })
        }
      }
      this.newPlan.expectedPrice = this.getTotalPrice
      if (!this.hasTermsError && !this.hasDomainError) {
        this.$emit('onConfirm', this.newPlan, pvLimits)
      }
    },

    onBack () {
      this.step = 1
    },

    onCloseLayer () {
      this.step = null
      this.$emit('closeLayer')
    },

    setPlanActive (plan) {
      this.planActive = plan
    },
    contactUs (info) {
      let form = this.$t('plan.contactForm')
      let pvUnit = info.product === 'Agency' ? this.$t('pricing.pvUnit.year') : this.$t('pricing.pvUnit.month')
      let cxUnit = info.product === 'Agency' ? this.$t('pricing.eaUnit.year') : this.$t('pricing.eaUnit.month')
      if (info === 'enterprise') {
        form = this.$t('plan.wireFormEnterprise')
      } else if (info === 'everyone') {
        form = this.$t('plan.wireFormEveryone')
      } else {
        if (this.$i18n.locale === 'ja') {
          form = this.$t('plan.newWireForm', {
            product: info.product,
            period: info.yearly ? '年間契約' : '月間契約',
            payment: info.paymentType === 'card' ? 'クレジットカード決済' : '銀行振込',
            pv: thousand(info.pvLimit) + pvUnit,
            aiReportCredit: info.aiReportCredit + cxUnit,
            referral: info.referral ? `${this.$t('referral.referralCode')}: ${info.referral}\n\n` : '',
            price: thousand(info.price)
          })
        } else if (this.$i18n.locale === 'en') {
          form = this.$t('plan.newWireForm', {
            product: info.product,
            period: info.yearly ? 'Use annually' : 'Use monthly',
            payment: info.paymentType === 'card' ? 'Pay by card' : 'Pay by bank transfer',
            pv: thousand(info.pvLimit) + pvUnit,
            aiReportCredit: info.aiReportCredit + cxUnit,
            referral: info.referral ? `${this.$t('referral.referralCode')}: ${info.referral}\n\n` : '',
            price: thousand(info.price)
          })
        } else {
          form = this.$t('plan.newWireForm', {
            product: info.product,
            period: info.yearly ? '연간으로 이용' : '월간으로 이용',
            payment: info.paymentType === 'card' ? '카드' : '무통장입금',
            pv: thousand(info.pvLimit) + pvUnit,
            aiReportCredit: info.aiReportCredit + cxUnit,
            referral: info.referral ? `${this.$t('referral.referralCode')}: ${info.referral}\n\n` : '',
            price: thousand(info.price)
          })
        }
      }
      // if (isDowngrade === true) {
      //   form = this.$t('plan.downgradeForm', { planName: this.planData.planName }, true)
      // }
      openContactUs(this.userData, form, true)
      this.onCloseLayer()
    },
    isPlanChange (isPayments = false, planData = null, isNext = false) {
      this.selectedPlan = {}
      if (planData) {
        this.selectedPlan = {
          pvLimit: Number(planData.pv),
          price: Number(planData.price),
          originPrice: Number(planData.originPrice),
          planNumber: planData.planNumber ? Number(planData.planNumber) : Number(this.newPlan.planNumber),
          planName: planData.type,
          referral: planData.referral
        }
      }
      if (isPayments) {
        getCardInfo('ba').then(data => {
          if (this.planData.applyType !== 'admin' && (!data || (!data.importCustomerUid && !data.tossBillingKey))) {
            // this.registerData = {
            //   customerUid: null
            // }
            this.$emit('openRegCard')
          } else {
            this.onPlanChange(this.selectedPlan.planNumber, false, isNext)
          }
        }).catch(err => {
          if (!err.isHandled) {
            openDialog({
              dialogType: 'common.error'
            })
          }
        })
      } else {
        this.onPlanChange(this.newPlan.planNumber, false, isNext)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.template-pricing {

  display: flex;
  justify-content: center;

  width: 100%;

  .contents {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;

    & > .options {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 30px;

      box-sizing: border-box;
      width: 100%;
      padding: 30px;

      .option {
        cursor: pointer;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;

        width: 268px;
        height: 507px;
        border-radius: 14px;
        box-shadow: 0 15px 15px -5px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);

        transition: all 0.5s ease;
        padding: 40px 20px 20px;
        box-sizing: border-box;
        z-index: 0;
        &:hover {
          transform: scale(1.02);
          z-index: 1;
        }

        .arrow-right {
          width: 18px;
          height: 18px;

          background: url(../../../assets/img/plan/icon-arrow-right.svg) no-repeat center center;
        }

        &.recommend {
          position: relative;
          border: solid 4px #ec0047;
          margin: -4px;

          box-shadow: 0 15px 15px -5px rgba(0, 0, 0, 0.16);

          span.recommend {
            position: absolute;
            top: 15px;
            color: #FFF;
            font-size: 12px;
            font-weight: 700;
            border-radius: 3px;
            background: #EC0047;
            padding: 4px 5px;
          }
          &:not(.custom) {
            pointer-events: none;
          }
          &:hover {
            transform: scale(1);
          }
        }

        &-recommend-image {
          position: absolute;
          top: 0;
          left: 0;

          background: url(../../../assets/img/plan/pricing-recommend.svg) no-repeat;
          width: 88px;
          height: 90px;

          &.en {
            background: url(../../../assets/img/plan/pricing-recommend-en.svg) no-repeat;
          }

          &.ja {
            background: url(../../../assets/img/plan/pricing-recommend-ja.svg) no-repeat;
          }
        }

        &-title {
          position: relative;

          width: 100%;
          color: #333;
          font-size: 30px;
          font-weight: 700;
          text-align: center;

          .sub {
            display: block;
            position: absolute;
            top: 40px;

            width: 100%;

            font-size: 18px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            text-align: center;
            color: #0e99af;
            word-break: keep-all;
          }
        }

        &-main-image {
          margin-top: 20px;

          width: 184px;
          height: 108px;

          &.everyone {
            background: url(../../../assets/img/plan/everyone.svg) no-repeat;
          }
          &.pro {
            background: url(../../../assets/img/plan/pro.svg) no-repeat;
          }
        }

        &-pv {
          color: #EC0047;
          font-size: 18px;
          font-weight: 700;
          line-height: 16px;
          text-align: center;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        &-icon {
          margin-bottom: -10px;
        }

        .custom {
          margin-top: 36px;
        }

        &-report {
          color: #444;
          text-align: center;
          font-size: 13px;
          font-weight: 600;
          line-height: 15px; /* 115.385% */
        }

        &-pv-select {
          margin-top: 14px;
          height: 40px;
          padding: 9px 36px 11px 12px;
          border-radius: 6px;
          border: solid 1px #b1b1b1;

          background: url(../../../assets/img/plan/icon-arrow-down.svg) no-repeat 92% 50%;

          font-size: 20px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          color: #2f2f2f;

          appearance: none;
        }

        &-price {
          color: #333;
          font-size: 30px;
          font-weight: 700;
          &-wrap {
            display: flex;
            align-items: center;
            position: relative;
            text-align: center;
            letter-spacing: -0.7px;
            &.only-free {
              margin-top: 27px;
              font-size: 20px;
              line-height: 140%; /* 28px */
            }

            &.only-custom {
              font-size: 20px;
              line-height: 140%; /* 28px */
            }
          }
          &-unit {
            text-align: center;
            line-height: 140%; /* 42px */
          }
        }

        &-price-cancel {
          font-size: 18px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.61;
          color: #ec0047;
          text-decoration: line-through;
        }

        &-btn {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;

          width: 180px;
          padding: 15px;
          border-radius: 25px;

          background-color: #ec0047;

          cursor: pointer;

          font-size: 18px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          color: #fff;
          text-decoration: none;

          &:hover {
            background-color: #c60c3b;
          }

          &.disabled {
            background-color: rgba(0, 0, 0, 0.16);
            color: #fff;
            cursor: default;

            &:hover {
              background-color: rgba(0, 0, 0, 0.16);
            }
          }
        }

        .sale {
          position: absolute;
          top: -50%;
          right: -20px;
          width: 45px;
          height: 45px;

          background: url(../../../assets/img/plan/sale.svg);
        }

        &-spec {
          display: flex;
          flex-direction: column;

          .item-description {
            font-size: 15px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.7;
            color: #444;
            text-align: center;
          }

          .item-check-list {
            display: flex;
            flex-direction: column;
            row-gap: 6px;
          }

          .item-check {
            display: flex;
            align-items: center;
            padding-left: 25px;

            background: url(../../../assets/img/icon_check_green_size16.svg) no-repeat 0% 50%;

            font-size: 13px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.54;
            color: #444;
          }

          .item-detail {
            display: flex;
            justify-content: center;
            align-content: center;

            margin-top: 6px;

            font-size: 12.5px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #888;
          }

          .item-info-list {
            display: flex;
            flex-direction: column;
            align-items: center;
            row-gap: 12px;
            height: 126px;

            .item {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 5px;
              width: 230px;

              color: #444;
              text-align: center;
              font-size: 13px;
              font-weight: 500;
              line-height: 15px; /* 115.385% */

              &.special {
                color: #7e36e0;
              }

              & .item-title {
                display: flex;
                align-items: center;
                gap: 4px;

                & > .icon-ai {
                  top: -1px;
                }
              }

              &-benefit {
                color: #333;
                font-size: 12px;
                font-weight: 400;
                margin-bottom: 4px;
              }

              .additional-info {
                position: relative;

                width: 15px;
                height: 15px;
                background: url(../../../assets/img/icon_info_small.svg) no-repeat;
                background-size: cover;
                &.pop .info-bubble,
                &:hover .info-bubble {
                  display: block;
                  .popup-contents-wrap {
                    .pop-item {
                      margin-bottom: 35px;
                      display: flex;
                      text-align: left;
                      gap: 15px;
                      &:last-child {
                        margin: 0;
                      }
                      .text {
                        max-width: 120px;
                        word-break: keep-all;
                        &.ja {
                          word-break: break-all;
                        }
                        span.label {
                          display: inline-block;
                          margin-bottom: 6px;
                          padding: 5px;
                          border-radius: 4px;
                          background-color: #ff2d92;
                          font-family: 'rubrik-new';
                          font-size: 10px;
                          font-weight: 600;
                          color: #fff;
                          text-align: center;
                          line-height: 1;
                        }
                      }
                    }
                  }
                  &.list {
                    .pop-item {
                      margin-bottom: 25px;
                      flex-direction: column;
                      gap: 10px;
                      .title {
                        font-size: 15px;
                        font-weight: 700;
                      }
                      .text {
                        max-width: 200px;
                      }
                    }
                  }
                }

                .info-bubble {
                  display: none;
                  width: max-content;
                  max-width: 500px;
                  position: absolute;
                  right: -45px;
                  bottom: 25px;

                  box-sizing: border-box;
                  padding: 16px;
                  border-radius: 10px;

                  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
                  background-color: #fff;
                  font-size: 13px;
                  font-weight: 500;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.46;
                  text-align: start;
                  color: #767676;

                  z-index: 10;
                  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
                  &:lang(ja) {
                    font-size: .9em;
                  }
                  &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    right: 46px;
                    width: 0;
                    height: 0;
                    border: 7px solid transparent;
                    border-top-color: #fff;
                    border-bottom: 0;
                    margin-bottom: -7px;
                  }

                  .pro-only {
                    width: 55px;
                    margin-bottom: 6px;
                    padding: 5px;
                    border-radius: 4px;
                    background-color: #7e36e0;

                    font-family: NewRubrik;
                    font-size: 10px;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    color: #fff;
                    text-align: center;
                    line-height: 1
                  }
                }
              }
            }
          }
        }
        &.everyone {
          .option-price {
            font-size: 20px;
            line-height: 1.4;
          }
          .info-bubble.img {
            right: -100px !important;
            &:after {
              right: 100px !important;
            }
          }
        }
        &.en {
          .option-spec .item-info-list {
            row-gap: 8px;
          }
          &.custom  {
            .option-price {
              margin-top: -16px;
            }
          }
        }
        &.ja {
          &.custom  {
            .option-price {
              margin-top: -16px;
            }
          }
        }
      }
    }

    & > .expand-wrap {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 32px;
      padding: 0 30px 30px;
      box-sizing: border-box;

      .option {
        cursor: pointer;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 40px;

        flex: 1;
        height: 220px;
        flex-shrink: 0;
        border-radius: 14px;
        box-shadow: 0 15px 15px -5px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);

        transition: all 0.5s ease;
        box-sizing: border-box;
        padding-top: 30px;
        padding-left: 35px;

        &:hover {
          transform: scale(1.02);
        }

        .option-title {
          font-size: 30px;
          font-weight: 700;
          line-height: 1;
          text-align: left;
          color: #222;
        }

        .option-container {
          display: flex;
          gap: 8px;

          .option-text-wrap {
            display: flex;
            flex-direction: column;
            gap: 8px;

            .option-sub {
              text-align: left;
              color: #333;
              font-size: 20px;
              font-weight: 700;
              line-height: 140%; /* 28px */
            }

            .option-desc {
              color: #333;
              font-size: 14px;
              font-weight: 600;
              line-height: 16px; /* 114.286% */
              text-align: left;
            }
          }

        }

        .icon-wrap {
          position: absolute;
          right: 20px;
          bottom: 10px;
        }
      }
    }

    & > .manual {
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.61;
      text-align: center;
      color: #555;
    }
  }
}
.plan-subscription--wrap {
  position: relative;
  box-sizing: border-box;
  padding: 50px 40px 37px 40px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  text-align: center;
  transition: width 0.2s cubic-bezier(.28,.12,.42,.94),
  height 0.2s cubic-bezier(.28,.12,.42,.94);
  overflow: hidden;
  width: 970px;
  height: 653px;

  &.downgrade {
    height: 668px;
  }

  &.step-2 {
    width: 530px;
    height: 737px;

    &.short {
      height: 730px;
    }

    &.downgrade {
      height: 668px;
    }
  }

  .accent {
    color: #EC0047;
  }

  .step {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    max-height: 100%;
    overflow: auto;

    &.fade-enter-active,
    &.fade-leave-active {
      opacity: 1;
    }
    &.fade-enter,
    &.fade-leave-to{
      opacity: 0;
    }
    &.fade-second-enter-active,
    &.fade-second-leave-active {
      opacity: 1;
    }
    &.fade-second-enter,
    &.fade-second-leave-to{
      opacity: 0;
    }
  }

  .plan-list {
    width: 100%;
    height: 100%;
    overflow-y: hidden;

    .icon--close-size16 {
      position: absolute;
      top: 12px;
      right: 12px;
    }

    .title {
      margin-top: 30px;
      font-size: 20px;
      color: #444444;
      text-align: start;
      padding-left: 30px;
    }

    .description {
      margin-top: 11px;
      font-size: 13px;
      line-height: 1.46;
      color: #666666;
      height: 18px;
      text-align: start;
      padding-left: 30px;
    }

    .plans {
      .plan {
        position: relative;
        display: inline-block;
        width: 381px;
        height: 482px;
        margin: 32px 12px 27px 12px;
        border-radius: 12px;
        box-shadow: 0 0 0 2px transparent, 0 7px 13px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        vertical-align: top;
        transition: box-shadow 0.3s ease;
        cursor: pointer;

        &.active {
          box-shadow: 0 0 0 2px #ec0047, 0 7px 13px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
        }

        .ribbon {
          position: absolute;
          top: -1px;
          left: -1px;
          display: block;
          background-image: url(../../../assets/img/plan/asset--open-discount-en.svg);
          width: 99px;
          height: 101px;

          &.ko {
            background-image: url(../../../assets/img/plan/asset--open-discount-ko.svg);
          }

          &.ja {
            background-image: url(../../../assets/img/plan/asset--open-discount-ja.svg);
          }
        }

        h4 {
          font-size: 28px;
          font-weight: 500;
          margin-top: 37px;
        }

        .image {
          margin: 10px auto;
          height: 125px;
          background-size: contain;
          background-position: center center;
          background-repeat: no-repeat;
        }

        .features {
          margin: 21px 0 34px 0;
          height: 149px;

          li {
            position: relative;
            text-align: left;
            margin: 15px 50px 16px;
            color: #444444;
            font-size: 13px;

            &::before {
              position: absolute;
              z-index: 1;
              content: "";
              border-top: 1px dashed #aaaaaa;
              top: calc(50% - 1px);
              left: 0;
              width: 100%;
            }

            .name {
              background: #ffffff;
              position: relative;
              z-index: 2;
              padding-right: 10px;

              i {
                vertical-align: middle;
                margin: -1px 0;
                position: relative;
                top: -1px;
              }
            }

            .desc {
              background: #ffffff;
              position: relative;
              z-index: 2;
              float: right;
              padding-left: 9px;
            }

            .tooltip {
              position: absolute;
              top: 0;
              right: -15px;
              white-space: nowrap;

              span {
                display: inline-block;
                vertical-align: middle;
                font-size: 12px;
                color: #767676;
              }

              .tip-item {
                display: block;
                text-align: left;

                &.left-side,
                &.right-side {
                  display: inline-block;
                }
              }

              .asset--view-more {
                display: block;
                margin: 0 auto 15px;
                background-image: url(../../../assets/img/plan/asset--view-more.svg);
                width: 233px;
                height: 157px;
              }

              .asset--view-more--pro1 {
                margin: 5px 12px 10px 0;
                background-image: url(../../../assets/img/plan/asset--view-more--pro1.svg);
                background-position: bottom right;
                background-repeat: no-repeat;
                width: 151px;
                height: 100px;
              }

              .asset--view-more--pro2 {
                margin: 10px 12px 5px 0;
                background-image: url(../../../assets/img/plan/asset--view-more--pro2.svg);
                width: 151px;
                height: 100px;
              }

              .description-pvlimit-1 {
                display: block;
                font-size: 13px;
                min-width: 131px;
                font-weight: 700;
                color: #2f2f2f;
                margin: 10px 0;

                & /deep/ span {
                  color: #ec0147;
                }
              }

              .description-pvlimit-2 {
                display: block;
                text-align: left;
                margin: 5px 10px 5px 15px;
              }
            }

            &.campaign {
              &::before {
                border-top-color: #7e36e0;
              }

              .name {
                color: #7e36e0;
              }

              .desc {
                color: #7e36e0;
              }
            }
          }
        }

        .buttons {
          .ui-btn {
            margin: 0 3px 0 2px;
          }

          .button-wrap {
            position: relative;

            .upper-text {
              position: absolute;
              color: #ec0047;
              font-size: 12px;
              top: -32px;
              left: 50%;
              white-space: nowrap;
              transform: translateX(-50%);
            }
          }

          .vat {
            font-size: 11px;
            color: #ff6200;
            margin-top: 9px;
          }
        }

        &.everyone {
          .image {
            margin-top: 16px;
            transform: translate(4px, 3px);
            width: 153px;
            background-image: url(../../../assets/img/plan/character--everyone.svg);
          }

          h4 {
            color: #0e99af;
          }

          .buttons {
            .ui-btn {
              min-width: 164px;
            }
          }

          .features {
            margin-top: 45px;
            margin-bottom: 4px;
          }
        }

        &.pro {
          .image {
            transform: translate(-3px, 1px);
            width: 224px;
            background-image: url(../../../assets/img/plan/character--pro.svg);
          }

          h4 {
            color: #7e36e0;
          }

          .buttons {
            .ui-btn {
              min-width: 134px;
            }
          }
        }
      }
    }

    .tip {
      color: #666;
      font-size: 13px;
      padding-top: 20px;
      padding-bottom: 27px;
    }
  }

  .plan-confirm {
    width: 100%;
    height: 100%;
    border-radius: 14px;
    background-color: #ffffff;
    transition: opacity 0.2s ease;
    text-align: left;

    .title {
      font-size: 15px;
      font-weight: 500;
      color: #2f2f2f;
      padding: 31px 30px;
    }

    .plan-to-plan {
      padding: 0 30px;

      .current,
      .next {
        display: inline-block;
        width: calc(50% - 22px);
        text-align: center;
        height: 85px;
        vertical-align: middle;

        h4 {
          font-size: 13px;
          color: #444444;
          margin-top: 6px;
        }

        p {
          font-size: 26px;
          font-weight: 500;
          color: #ec0047;
          margin-top: 11px;
        }

        .price {
          margin-top: 13px;
        }
      }

      .arrow {
        display: inline-block;
        width: 44px;
        height: 44px;
        vertical-align: middle;

        i {
          width: 44px;
          height: 44px;
        }
      }

      .renew-price {
        border-radius: 5px;
        border: solid 1px #d7d7d7;
        background-color: #f4f4f4;
        margin: 3px 0 10px;
        text-align: left;
        padding: 17px 29px 15px 30px;

        .price__wrap {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name {
            font-size: 14px;
            color: #666666;
            padding: 27px 0;
            display: inline-block;
          }

          .number {
            float: right;
            text-align: right;
            padding: 13px 0;

            strong {
              display: block;
              font-size: 20px;
              font-weight: 500;
              color: #2f2f2f;
            }

            span {
              display: block;
              font-size: 12px;
              margin-top: 10px;
            }
          }
          .value{
            strong {
              display: block;
              font-size: 20px;
              font-weight: 500;
              color:#ec0047;
            }
          }
          &.plan-info {
            flex-direction: column;
            gap: 14px;
            padding: 20px 0;
            .price-item {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .name {
                padding: 0;
              }

              .value {
                display: flex;
                flex-direction: column;
                gap: 6px;
                align-items: flex-end;
              }
            }
          }
          &.transferRemain {
            border-top: 1px solid #c3c3c3;
            padding: 10px 0;
            .value strong {
              text-align: right;
              line-height: 1.2;
              color: #2f2f2f;
            }
          }
        }
        .dashed-line {
          border: 1px dashed #d7d7d7;
        }
      }

      .description {
        font-size: 13px;
        line-height: 1.46;
        color: #777777;
        margin: 25px 0 20px 0;

        &.downgrade {
          li:last-child {
            color: #EC0047
          }
        }

        &.upgrade {
          li:nth-child(n+4) {
            color: #EC0047
          }
        }

        li {
          position: relative;
          margin: 7px 10px;
          padding: 0 12px;

          &::before {
            content: "";
            display: block;
            position: absolute;
            top: 7px;
            left: 0;
            width: 3px;
            height: 3px;
            background-color: #888888;
          }
        }
      }
    }

    .restriction {
      border-top: dashed 1px #d7d7d7;
      margin: 0 40px;
      padding-bottom: 7px;

      h4 {
        font-size: 13px;
        line-height: 1.46;
        color: #2f2f2f;
        padding-top: 27px;

        i {
          margin-bottom: 3px;
          margin-right: 3px;
          vertical-align: middle;
        }
      }

      .features {
        font-size: 13px;
        line-height: 1.46;
        color: #777777;
        margin: 19px 0 20px 0;
        counter-reset: feature;

        .features-desc {
          position: relative;
          margin: 16px 0;
          padding: 0 6px 0 18px;
          white-space: nowrap;

          &::before {
            counter-increment: feature;
            content: counter(feature) ".";
            display: block;
            position: absolute;
            top: 0;
            left: 1px;
            color: #888888;
          }

          h5 {
            color: #ec0047;
            margin-bottom: 8px;
          }

          p {
            line-height: 1.5;
            font-size: 12px;

            & /deep/ span {
              color: #ec0047;
            }
          }
        }
      }

      .pvlimit-list {
        position: relative;
        border-radius: 6px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        margin: -7px 0 19px;
        overflow: hidden;
        transition: height 0.3s ease,
        padding 0.3s ease;

        &:not(.active) {
          height: 36px;
        }

        &.active {
          h6 {
            .title-tip {
              opacity: 1;
            }
          }
        }

        &.overflow {
          overflow: visible;
        }

        .icon--drop-down {
          position: absolute;
          z-index: 1;
          top: 10px;
          right: 10px;
          transition: transform 0.2s ease;
        }

        h6 {
          position: relative;
          z-index: 1;
          font-size: 14px;
          color: #2f2f2f;
          padding: 12px 12px 6px;
          cursor: pointer;
          border-radius: 6px;

          .title-tip {
            display: inline-block;
            vertical-align: top;
            transform: translateY(-1.5px);
            margin-left: 5px;
            opacity: 0;
            transition: opacity 0.2s ease;
          }
        }

        p {
          font-size: 12px;
          line-height: 1.58;
          color: #888888;
          padding: 0 12px;
        }

        ul {
          padding: 15px 13px 13px;

          li {
            padding: 1px 0 1px;
            border-bottom: dashed 1px #c2dbed;

            &:last-child {
              border-bottom: none;
            }

            .domain {
              display: inline-block;
              vertical-align: top;
              width: 260px;
              padding: 20px 10px 0 0;

              .ui_checkbox {
                display: inline-block;
                margin-left: 10px;
                width: 100%;

                & /deep/ {
                  .text {
                    display: inline-block;
                    vertical-align: middle;
                    margin-top: -0.5px;
                    font-size: 13px;
                    color: #666666;
                    width: calc(100% - 38px);
                    margin-left: 28px;
                    word-break: break-all;
                  }
                }
              }
            }

            .rate {
              position: relative;
              display: inline-block;
              vertical-align: top;
              width: 125px;
              text-align: right;

              .slider {
                margin: 12px 0 0 4px;

                & /deep/ {
                  .ui_select {
                    margin-right: -5px;

                    .icon--drop-down {
                      right: 7px;
                    }

                    &.disabled {
                      .selected-item {
                        font-size: 13px;
                        text-align: center;

                        span {
                          margin-right: 5px;
                        }

                        .icon {
                          display: none;
                        }
                      }
                    }

                    .item--wrap {
                      height: 32px;
                      font-size: 13px;
                      line-height: 32px;
                      padding-left: 10px;

                      .selected-item {
                        & > span {
                          margin-top: -1px;
                        }
                      }

                      .item__list {
                        transform-origin: bottom;
                        top: auto;
                        bottom: -1px;

                        .item__list-item {
                          height: 32px;
                          padding-left: 10px;
                        }
                      }
                    }
                  }
                }
              }

              .input {
                margin: 5px -5px 10px auto;
                width: 120px;
                height: 32px;
                opacity: 1;
                position: relative;
                overflow: hidden;
                transition: opacity 0.2s ease,
                height 0.2s ease,
                margin-top 0.2s ease;

                &.hidden {
                  margin-top: 2px;
                  height: 0;
                  opacity: 0;
                }

                & /deep/ {
                  .above-input {
                    margin-top: 0;
                  }

                  .label {
                    display: none;
                  }

                  input {
                    padding: 0 8px;
                    line-height: 32px;
                    height: 32px;
                    text-align: left;
                    font-size: 13px;
                  }

                  .icon--close14 {
                    right: -3px;
                  }
                }
              }
            }
          }
        }

        &.active {
          border-color: #289eef;
          background-color: #f8fcff;
          padding: 5px;

          .icon--drop-down {
            transform: scaleY(-1);
          }
        }
      }

      &.upgrade {
        .features {
          margin-top: 9px;

          .features-desc {
            margin-top: 5px;
            margin-bottom: 7px;
            white-space: nowrap;
          }
        }
      }
    }

    .confirm-content {
      max-height: calc(100% - 149px);
      overflow: auto;
      .payment-method-selector {
        display: flex;
        justify-content: center;
        width: 430px;
        border: 1px solid #e0e0e0;
        background-color: #ffffff;
        transition: background-color 0.3s ease, border-color 0.3s ease;
        border-radius: 20px;
        position: relative;
        margin: 0 auto;
        margin-bottom: 40px;
        .payment-type {
          width: 210px;
          text-align: center;
          line-height: 36px;
          height: 36px;
          color: #888888;
          position: relative;
          font-size: 15px;
          z-index: 2;
          transition: color 0.3s ease;

          &:first-child {
            box-sizing: border-box;
            padding-right: 5px;
          }

          &:last-child {
            box-sizing: border-box;
            padding-right: 5px;
          }

          i {
            vertical-align: middle;
            transform: translateY(-1px);
            width: 0;
            transition: width 0.3s ease, margin 0.3s ease;
          }

          &.on {
            color: #ffffff;

            i {
              width: 20px;
              margin: 0 20px 0 0;
            }
          }
          &.disabled {
            opacity: .3;
            pointer-events: none;
          }
        }
        &:before {
          content: "";
          position: absolute;
          z-index: 1;
          top: -1px;
          background: #ec0147;
          border-radius: 20px;
          transition: left 0.3s cubic-bezier(0.25, 1, 0.5, 1);
          display: block;
          width: 220px;
          height: 38px;
          box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.25);
        }
        &.card:before {
          left: -1px;
        }
        &.bank:before {
          right: -1px;
        }
      }
    }

    .footer {
      position: relative;
      margin: 0 30px;
      padding: 25px 0 27px;
      border-top: 1px solid #d8d8d8;
      text-align: center;

      &:before {
        content: "";
        width: 100%;
        height: 30px;
        position: absolute;
        top: -31px;
        left: 0;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
      }

      .footer-description {
        line-height: 16px;
        height: 16px;
      }

      .button--wrap {
        margin-top: 42px;

        button {
          min-width: 100px;
        }

        .btn__confirm {
          margin-left: 5px;
        }
      }

      .ui_checkbox {
        margin-left: 0;
      }

      .terms-agree {
        position: relative;
        text-align: left;
        font-size: 13px;
        color: #2f2f2f;
      }

      .terms-agree-validation-text {
        position: absolute;
        top: 50px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 13px;
        color: $brandColor;
        white-space: nowrap;
        display: inline-block;
      }
    }
  }
}
</style>
